import React from 'react';
import formatDateTimeHuman from 'utils/formatDateTimeHuman';
import urlParams from 'utils/urlParams';
import classNames from 'classnames';
import {Map} from 'immutable';
import {formatDateTime} from 'components/manager-dashboard/Common';
import {browserHistory} from 'react-router';
import './MailRowContent.styl';
import MailActions from 'actions/inbox/MailActions';
import moment from 'moment';
import TagActions from 'actions/TagActions';
import ShareToggle from 'components/inbox/mail-table/toggles/ShareToggle';
import PinToggle from 'components/inbox/mail-table/toggles/PinToggle';
import TrendActionTypeIcon from 'components/pure/utils/icon/triggers/TrendActionTypeIcon';
import renderDescription from 'components/inbox/mail-table/functions/RenderDescription';
import pick from 'lodash/pick';
import NavActions from 'actions/NavActions';

const ID_PROP_LOOKUP = {
  COMMENT: 'commentId',
  HIGHLIGHT: 'highlightId',
  SCORECARD_COMMENT: 'scorecardAnswerId',
};

const ZERO_TITLE = '0 matching calls';

export default class MailRowContent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.goToDetails = this.goToDetails.bind(this);
    this.clickRow = this.clickRow.bind(this);
  }

  clickRow() {
    const {item, filters} = this.props;
    const shouldLink = item.linkTitle !== ZERO_TITLE;
    if (shouldLink) {
      this.goToDetails();
    } else {
      const ids = item.getIds();

      MailActions.bulkMarkAsRead({ids: ids, folderId: filters.folderId}).then(
        NavActions.inboxMentionsCount
      );
    }
  }

  goToDetails() {
    const {item, filters} = this.props;

    const ids = item.getIds();

    MailActions.bulkMarkAsRead({ids: ids, folderId: filters.folderId}).then(
      NavActions.inboxMentionsCount
    );

    if (!item.viewedDate) {
      MailActions.saveMail(item.set('viewedDate', moment()), item);
      TagActions.clearTags();
    }

    const isTrendNotification = item.context.type === 'trend_notification';

    // if we are going to call history from the "Shared With Me" tab, add to url with sharerId and permalink
    const shareParams =
      item.context.type === 'call_shared' && item.context.shareId
        ? pick(item.context, ['shareId', 'permalink'])
        : {};

    const mentionedParams =
      item.context.type === 'Mentioned'
        ? {[ID_PROP_LOOKUP[item.context.modelType]]: item.context.id}
        : {};

    const params = urlParams(Map(filters).merge({...shareParams, ...mentionedParams}));

    const detailView = isTrendNotification
      ? `/inbox/trends/${item.context.ruleId}/calls?itemId=${item.id}`
      : `/fullscreen/items/${item.id}/calls/${item.call.id}${params}`;

    browserHistory.push(detailView);
  }

  render() {
    const {item} = this.props;
    const isTrendNotification = item.context.type === 'trend_notification';
    // not clickable if no items and already marked as read
    const shouldLink = item.linkTitle !== ZERO_TITLE || !item.viewedDate;
    const title = shouldLink ? item.linkTitle : 'No calls matched';

    return (
      <div
        className={classNames('content', 'mail-table-share-content', shouldLink || 'no-link')}
        onClick={() => (shouldLink ? this.clickRow() : null)}>
        <div className="description">
          {renderDescription(item)}

          {isTrendNotification ? (
            <div className="trend-description">
              <span className="trend-notif-icon">
                <TrendActionTypeIcon />
              </span>
              <span className={classNames(shouldLink && 'generic-link')}>{title}</span>
            </div>
          ) : (
            <div className="call-description">
              <span className="generic-link">{item.call.description}</span>
              {', '}
              {item.call.caller.getFullName()},{' '}
              <span className="call-date-time">{formatDateTimeHuman(item.call.datetime)}</span>
            </div>
          )}
        </div>
        <div className="item-date-time">{formatDateTime(item.created)}</div>
        <div className="actions">
          {!isTrendNotification && <ShareToggle item={item} />}
          <PinToggle item={item} />
        </div>
      </div>
    );
  }
}
